import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { getPublishedBlogs } from '../apis/blogApis';
import Loader from '../Components/Loader/Loader';
import { Helmet } from 'react-helmet-async';

function Blog() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const data = await getPublishedBlogs();
                setBlogs(data);
            } catch (err) {
                console.error("Failed to fetch blogs:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    return (
        <>
            {loading && <Loader />}
              <Helmet>
                <title>
                    Blogs | Cable Management & Electrical Solutions UAE | Al Ibtekar
                </title>

                <meta
                    name="description"
                    content="Read the latest Al Ibtekar blogs covering cable management, cable termination, electrical enclosures, industrial electrical solutions, E&I applications and industry insights in the UAE."
                />

                <meta
                    name="keywords"
                    content="Al Ibtekar blogs, cable management blog UAE, cable termination blog UAE, electrical solutions UAE, electrical enclosures UAE, cable management solutions UAE, E&I solutions UAE, industrial electrical blog UAE"
                />

                <meta
                    name="robots"
                    content="index, follow"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/blog"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Blogs | Cable Management & Electrical Solutions UAE | Al Ibtekar"
                />

                <meta
                    property="og:description"
                    content="Explore Al Ibtekar's latest insights on cable management, cable termination, electrical enclosures, industrial solutions and electrical & instrumentation applications."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/blog"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Al Ibtekar"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Blogs | Cable Management & Electrical Solutions UAE | Al Ibtekar"
                />

                <meta
                    name="twitter:description"
                    content="Latest cable management, cable termination, electrical and industrial solution insights from Al Ibtekar UAE."
                />
            </Helmet>


            <div className='newbanner-about newbanner-about6'>
                <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Blogs</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">
                        Sustainable and profitable cloud landscape
                    </p>
                </div>
            </div>

            <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] lg:pb-[80px] pb-[40px]'>
                {!loading && blogs.length === 0 ? (
                    <p className="text-center text-gray-500 py-20 text-lg">No blogs published yet.</p>
                ) : (
                    <div className='grid lg:grid-cols-4 grid-cols-1 lg:gap-[30px] gap-[20px]'>
                        {blogs.map((blog) => (
                            <div className='blogcard' key={blog._id}>
                                <div className='blogcard-img'>
                                    <img
                                        src={blog.imageUrl || '/assets/blog1.jpg'}
                                        alt={blog.title}
                                    />
                                </div>
                                <div className='blogcard-text'>
                                    <div>
                                        <h5>Blog</h5>
                                        <h3>{blog.title}</h3>
                                    </div>
                                    <Link to={`/blog/${blog.slug}`}>
                                        <button>Read More +</button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}

export default Blog;
